<div class="page">
  <div class="page__inner">
    <hrra-status-message
      [message]="'text.ActivationPageLinkInformation' | translate: { email: systemConfigs()?.jobseeker.contactEmail }"
      [actionLabel]="!maxResendAttemptsReached() && emailResendToken() != null ? ('label.ResendActivationEmail' | translate) : null"
      [warning]="maxResendAttemptsReached() ? ('message.MaxNumberOfAttemptsReached' | translate) : null"
      (action)="onResend()"
    ></hrra-status-message>
  </div>
</div>
